import { create } from 'zustand';

type WorkspaceState = {
  orgId: string | null;
  clientId: string | null;
  projectId: string | null;
  setOrgId: (orgId: string | null) => void;
  setClientId: (clientId: string | null) => void;
  setProjectId: (projectId: string | null) => void;
  reset: () => void;
};

export const useWorkspaceStore = create<WorkspaceState>((set) => ({
  orgId: null,
  clientId: null,
  projectId: null,
  setOrgId: (orgId) =>
    set((state) => ({
      orgId,
      clientId: orgId === state.orgId ? state.clientId : null,
      projectId: null
    })),
  setClientId: (clientId) =>
    set((state) => ({
      clientId,
      projectId: state.clientId === clientId ? state.projectId : null
    })),
  setProjectId: (projectId) => set({ projectId }),
  reset: () => set({ orgId: null, clientId: null, projectId: null })
}));

// Expose store for API header injection
(window as unknown as { __workspaceStore?: typeof useWorkspaceStore }).__workspaceStore = useWorkspaceStore;
